import { z } from 'zod';

export const startSearchSchema = z.object({
  draftId: z.string().trim().min(1).max(128).optional().catch(undefined),
  step: z.coerce.number().int().min(1).max(5).catch(1).default(1),
});

export const getStartDraftVariables = (draftId?: string) => ({
  draftId: draftId ?? '',
  hasDraft: draftId != null,
});
